/**
 * @generated SignedSource<<ae238e410eaf89e69249b0033c4b31b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobClientActions_Job$data = {
  readonly firm: {
    readonly self: boolean | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly slug: string | null | undefined;
  readonly " $fragmentType": "JobClientActions_Job";
};
export type JobClientActions_Job$key = {
  readonly " $data"?: JobClientActions_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobClientActions_Job">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobClientActions_Job",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Firm",
      "kind": "LinkedField",
      "name": "firm",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "self",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};
})();

(node as any).hash = "3298a73feee4bd4556cd907607fa5d80";

export default node;
